import './Contact.css';
import React, { useRef, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslate } from 'react-redux-multilingual';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import LoadingButton from '@mui/lab/LoadingButton';
import SendIcon from '@mui/icons-material/Send';

import {
    ValidateEmail,
    ValidatePersonName,
    ValidatePhoneNumber,
    IsEmptyString,
} from '../../../libraries/Tool';

import {
    SendMessage,
} from '../../../services/Auth.service';

function Contact(props) {
    const { translate, SnackbarAlert, UserInfor } = props;
    const { form } = useParams();
    const [loading, setLoading] = React.useState(false);
    const [email, setEmail] = React.useState();
    const [emailInvalid, setEmailInvalid] = React.useState(false);
    const [emailAlreadyInUse, setEmailAlreadyInUse] = React.useState(false);
    const [firstName, setFirstName] = React.useState();
    const [firstNameInvalid, setFirstNameInvalid] = React.useState(false);
    const [lastName, setLastName] = React.useState();
    const [lastNameInvalid, setLastNameInvalid] = React.useState(false);
    const [phoneNumber, setPhoneNumber] = React.useState();
    const [phoneNumberInvalid, setPhoneNumberInvalid] = React.useState(false);
    const [message, setMessage] = React.useState();
    const [messageInvalid, setMessageInvalid] = React.useState(false);

    const handleOnChangeEmail = (e) => {
        setEmail(e.target.value);
        setEmailInvalid(!ValidateEmail(e.target.value));
    }

    const handleOnChangeFirstName = (e) => {
        setFirstName(e.target.value);
        setFirstNameInvalid(!ValidatePersonName(e.target.value));
    }

    const handleOnChangeLastName = (e) => {
        setLastName(e.target.value);
        setLastNameInvalid(!ValidatePersonName(e.target.value));
    }

    const handleOnChangePhoneNumber = (e) => {
        setPhoneNumber(e.target.value);
        setPhoneNumberInvalid(!ValidatePhoneNumber(e.target.value));
    }

    const handleOnChangeMessage = (e) => {
        setMessage(e.target.value);
        setMessageInvalid(IsEmptyString(e.target.value));
    }

    const handleCloseSnackbarAlert = () => {
        props.dispatch({ type: 'UPDATE_SNACKBARALERT', SnackbarAlert: { ...SnackbarAlert, open: false } });
    }

    const onClickSend = (e) => {
        e.preventDefault();
        let event;
        if(!email) setEmailInvalid(true);
        if(!firstName) setFirstNameInvalid(true);
        if(!lastName) setLastNameInvalid(true);
        if(!phoneNumber) setPhoneNumberInvalid(true);
        if(!message) setMessageInvalid(true);
        if(
            email &&
            firstName &&
            lastName &&
            phoneNumber &&
            message &&
            !emailInvalid && 
            !firstNameInvalid && 
            !lastNameInvalid &&
            !phoneNumberInvalid &&
            !messageInvalid
        ) {
            setLoading(true);
            event = SendMessage({
                email
                ,firstName
                ,lastName
                ,phoneNumber
                ,message
            });
            setTimeout(() => {
                Array.from(document.querySelectorAll("input,textarea")).forEach(
                input => (input.value = "")
                );
            }, 1000)
        }
        event?.then(res => {
            setLoading(false);
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: res?.data?.status,
                        message: translate(`${res?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            }, 1000)
        })
        .catch(err => {
            setLoading(false);
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: err?.response?.data?.status,
                        message: translate(`${err?.response?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            }, 1000)
        })
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        if(form === "upgrade") {
            setEmail(UserInfor.email);
            setFirstName(UserInfor.firstName);
            setLastName(UserInfor.lastName);
            setMessage(translate('iwouldliketoupgradepackage'));
        }
    }, [])

    return (
        <div>
            <Container maxWidth="xl" sx={{ my: 10 }}>
                <Typography variant="h4" gutterBottom component="div" sx={{ textAlign: "left", fontWeight: "bold", py: 5 }}>
                    {translate('talktous')}
                </Typography>
                <Typography variant="h6" gutterBottom component="div" sx={{ textAlign: "left" }}>
                    {translate('talktousdescription')}
                </Typography>
                <Typography variant="h6" gutterBottom component="div" sx={{ textAlign: "left", mb: 3 }}>
                    {`${translate('talktousdescription2')} ${translate('email')}`} <Link underline="none" href={`mailto:${process.env.REACT_APP_INFOR_SALE_MAIL}`}>{process.env.REACT_APP_INFOR_SALE_MAIL}</Link> {` ${translate('orphone')} `} <Link underline="none" href={`tel:${process.env.REACT_APP_INFOR_SALE_TEL}`}>{process.env.REACT_APP_INFOR_SALE_TEL}</Link>
                </Typography>
                <Box
                    component="form"
                    noValidate
                    autoComplete="off"
                    className="contact-box-main"
                    onSubmit={onClickSend}
                >
                    <Grid>
                        <Grid container xs={12} md={6} sx={{ mb: 2 }} spacing={2}>
                            <Grid item xs={12} md={12}>
                                <TextField
                                    autoFocus
                                    required
                                    type="email"
                                    fullWidth
                                    id="email"
                                    name="email"
                                    autoComplete="none"
                                    label={translate('emailaddress')}
                                    value={email}
                                    onChange={handleOnChangeEmail}
                                    error={
                                        emailInvalid || emailAlreadyInUse
                                    }
                                    helperText={
                                        (emailInvalid) ? translate('pleaseenteravalidemailaddress') :
                                        (emailAlreadyInUse) ? translate('emailalreadyinuse') :
                                        ""
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    required
                                    fullWidth
                                    id="firstName"
                                    name="firstName"
                                    autoComplete='none'
                                    label={translate('firstname')}
                                    value={firstName}
                                    onChange={handleOnChangeFirstName}
                                    error={firstNameInvalid}
                                    helperText={
                                        firstNameInvalid ? translate('pleaseenteravalidfirstname') :
                                        ""
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    required
                                    fullWidth
                                    id="lastName"
                                    name="lastName"
                                    autoComplete='none'
                                    label={translate('lastname')}
                                    value={lastName}
                                    onChange={handleOnChangeLastName}
                                    error={lastNameInvalid}
                                    helperText={
                                        lastNameInvalid ? translate('pleaseenteravalidlastname') :
                                        ""
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <TextField
                                    required
                                    type="text"
                                    fullWidth
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    label={translate('phonenumber')}
                                    value={phoneNumber}
                                    onChange={handleOnChangePhoneNumber}
                                    error={phoneNumberInvalid}
                                    helperText={
                                        phoneNumberInvalid ? translate('pleaseenteravalidphonenumber') :
                                        ""
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid container xs={12} md={12} sx={{ mb: 2 }}>
                            <Grid item xs={12} md={12}>
                                <TextField
                                    multiline
                                    required
                                    type="text"
                                    fullWidth
                                    rows={4}
                                    id="message"
                                    name="message"
                                    placeholder={translate('whatcanwehelpwith')}
                                    label={translate('message')}
                                    value={message}
                                    onChange={handleOnChangeMessage}
                                    error={messageInvalid}
                                    helperText={
                                        messageInvalid ? translate('pleaseenteravalidmessage') :
                                        ""
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sx={{ display: "flex", justifyContent: "left", pt: 4 }}>
                            <LoadingButton
                                endIcon={<SendIcon />}
                                loading={loading}
                                loadingPosition="end"
                                variant="contained"
                                type="submit"
                                onClick={onClickSend}
                                >
                                {translate('send')}
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </div>
    );
}

function mapStateToProps(state) {
    return {
      SnackbarAlert: state.SnackbarAlert,
      UserInfor: state.UserInfor,
    }
}

export default connect(mapStateToProps)(withTranslate(Contact));